// {% comment %}Script for product count update when go to previous page iftikhar{% endcomment %}

(function () {
  const CONFIG = {
    TARGET_SELECTOR: '#cart-icon-bubble',

    /*
      pageshow / visibility / focus kabhi
      ek saath fire ho sakte hain.

      Isliye duplicate refresh rokne ke liye
      minimum gap.
    */
    MIN_REFRESH_GAP: 1200
  };


  class CartUpdaterLite {

    constructor() {
      this.refreshTimer = null;
      this.lastRefreshAt = 0;
      this.refreshPromise = null;

      /*
        Initial page load aur actual
        background → foreground mein
        difference rakhne ke liye.
      */
      this.wasHidden = false;

      this.init();
    }


    /* =========================================
       INIT
    ========================================= */

    init() {

      /*
        MOST IMPORTANT EVENT:

        Safari / iPhone swipe-back
        aur browser Back button ke waqt
        BFCache page restore hota hai.

        persisted === true ka matlab:
        old cached page wapas aya hai.
      */
      window.addEventListener(
        'pageshow',
        (event) => {

          const navigation =
            performance.getEntriesByType(
              'navigation'
            )[0];

          const isBackForward =
            event.persisted ||
            navigation?.type === 'back_forward';


          if (isBackForward) {
            this.scheduleRefresh(20);
          }

        }
      );

      window.addEventListener(
        'popstate',
        () => {
          this.scheduleRefresh(50);
        }
      );


      /*
        User:
        Safari → another app → Safari
        ya
        another tab → store tab

        wapas aaye to cart sync.
      */
      document.addEventListener(
        'visibilitychange',
        () => {

          if (document.hidden) {

            this.wasHidden = true;

            return;
          }


          if (this.wasHidden) {

            this.wasHidden = false;

            this.scheduleRefresh(80);

          }

        }
      );


      /*
        Desktop browser/window focus fallback.

        Duplicate refresh MIN_REFRESH_GAP
        automatically rok dega.
      */
      window.addEventListener(
        'focus',
        () => {

          /*
            Initial page load ke immediately
            baad unnecessary request mat bhejo.
          */
          if (
            performance.now() < 1500
          ) {
            return;
          }


          this.scheduleRefresh(100);

        }
      );


      /*
        Optional manual API.

        Agar future mein kisi custom Add to Cart
        script se explicitly refresh karwana ho:

        window.__cartUpdater.refresh();
      */
      window.__cartUpdater = this;
    }


    /* =========================================
       SCHEDULE / DEDUPE
    ========================================= */

    scheduleRefresh(delay = 0) {

      clearTimeout(
        this.refreshTimer
      );


      this.refreshTimer =
        setTimeout(() => {

          this.refresh();

        }, delay);

    }


    /* =========================================
       FETCH CURRENT SHOPIFY CART
    ========================================= */

    async fetchCart() {

      const response =
        await fetch(
          '/cart.js',
          {
            method: 'GET',

            /*
              Cached cart response nahi chahiye.
            */
            cache: 'no-store',

            credentials: 'same-origin',

            headers: {
              Accept: 'application/json'
            }
          }
        );


      if (!response.ok) {

        throw new Error(
          'Unable to fetch cart'
        );

      }


      return response.json();
    }


    /* =========================================
       MAIN REFRESH
    ========================================= */

    async refresh() {

      const now =
        Date.now();


      /*
        pageshow + visibility + focus
        almost simultaneously fire ho sakte hain.

        Ek hi refresh enough hai.
      */
      if (
        now - this.lastRefreshAt <
        CONFIG.MIN_REFRESH_GAP
      ) {
        return this.refreshPromise;
      }


      /*
        Agar previous refresh abhi chal raha hai
        to doosra network request mat bhejo.
      */
      if (this.refreshPromise) {
        return this.refreshPromise;
      }


      this.lastRefreshAt =
        now;


      this.refreshPromise =
        this.performRefresh();


      try {

        await this.refreshPromise;

      } finally {

        this.refreshPromise =
          null;

      }
    }


    async performRefresh() {

      try {

        /*
          REQUEST 1:
          Current Shopify cart.
        */
        const cart =
          await this.fetchCart();


        /*
          Header count update.
        */
        this.updateCartCountUI(
          cart.item_count
        );


        /*
          Cart drawer bhi latest rakho.

          Ye sirf page restore / return par
          chalega — continuously nahi.
        */
        await this.updateDrawer(
          cart
        );


      } catch (error) {

        console.log(
          'CartUpdaterLite:',
          error
        );

      }

    }


    /* =========================================
       HEADER CART COUNT
    ========================================= */

    updateCartCountUI(itemCount) {

      /*
        Har mutation par wrapper store/query
        karne ki zarurat nahi.

        Sirf actual refresh ke waqt query.
      */
      const wrapper =
        document.querySelector(
          CONFIG.TARGET_SELECTOR
        );


      if (!wrapper) {
        return false;
      }


      let bubble =
        wrapper.querySelector(
          '.cart-count-bubble'
        );


      /*
        Cart bubble exist nahi karti
        aur items > 0 hain:
        bubble create kar do.
      */
      if (
        !bubble &&
        itemCount > 0
      ) {

        bubble =
          document.createElement(
            'div'
          );


        bubble.className =
          'cart-count-bubble';


        bubble.innerHTML =
          '<span aria-hidden="true">0</span>' +
          '<span class="visually-hidden">items in cart</span>';


        wrapper.appendChild(
          bubble
        );

      }


      /*
        Cart zero hai aur bubble pehle se
        exist hi nahi karti to aur kuch nahi.
      */
      if (!bubble) {

        wrapper.setAttribute(
          'data-cart-count',
          String(itemCount)
        );

        return true;

      }


      let span =
        bubble.querySelector(
          '[aria-hidden="true"]'
        );


      if (!span) {

        span =
          document.createElement(
            'span'
          );


        span.setAttribute(
          'aria-hidden',
          'true'
        );


        bubble.prepend(
          span
        );

      }


      const oldCount =
        parseInt(
          span.textContent,
          10
        ) || 0;


      /*
        Count update.
      */
      span.textContent =
        itemCount;


      wrapper.setAttribute(
        'data-cart-count',
        String(itemCount)
      );


      /*
        Accessibility label update.
      */
      const clickable =
        /^(A|BUTTON)$/i.test(
          wrapper.tagName
        )
          ? wrapper
          : wrapper.querySelector(
              'a, button'
            );


      if (clickable) {

        const currentLabel =
          clickable.getAttribute(
            'data-base-label'
          ) ||
          clickable.getAttribute(
            'aria-label'
          ) ||
          'Cart';


        const baseLabel =
          currentLabel.replace(
            /\s*\(\d+\)\s*$/,
            ''
          );


        clickable.setAttribute(
          'data-base-label',
          baseLabel
        );


        clickable.setAttribute(
          'aria-label',
          `${baseLabel} (${itemCount})`
        );

      }


      /*
        Zero cart → bubble hide.
      */
      bubble.style.display =
        itemCount > 0
          ? 'flex'
          : 'none';


      /*
        Count actually change hua hai tabhi
        little scale animation.

        Har refresh par animation nahi.
      */
      if (
        oldCount !== itemCount &&
        itemCount > 0
      ) {

        bubble.style.transition =
          'transform 0.2s ease';


        bubble.style.transform =
          'scale(1.22)';


        setTimeout(() => {

          /*
            Element meanwhile replace ho gaya
            ho to bhi harmless.
          */
          if (bubble.isConnected) {

            bubble.style.transform =
              'scale(1)';

          }

        }, 200);

      }


      return (
        oldCount !== itemCount
      );
    }


    /* =========================================
       CART DRAWER
    ========================================= */

    async updateDrawer(cart) {

      const drawer =
        document.querySelector(
          'cart-drawer'
        );


      /*
        Theme/page par drawer nahi hai:
        zero work.
      */
      if (!drawer) {
        return;
      }


      try {

        /*
          REQUEST 2 — ONLY WHEN RETURNING
          TO THE PAGE.

          Continuous polling nahi.
        */
        const response =
          await fetch(
            '/cart?section_id=cart-drawer',
            {
              method: 'GET',
              cache: 'no-store',
              credentials: 'same-origin'
            }
          );


        if (!response.ok) {
          return;
        }


        const html =
          await response.text();


        const doc =
          new DOMParser()
            .parseFromString(
              html,
              'text/html'
            );


        const newDrawer =
          doc.querySelector(
            'cart-drawer'
          );


        if (!newDrawer) {
          return;
        }


        /*
          Existing custom element ko preserve
          karte hue sirf content refresh.
        */
        drawer.innerHTML =
          newDrawer.innerHTML;


        drawer.classList.toggle(
          'is-empty',
          cart.item_count === 0
        );


        /*
          Drawer ka inner HTML replace hua hai,
          isliye new buttons ko listeners.
        */
        const overlay =
          drawer.querySelector(
            '#CartDrawer-Overlay'
          ) ||
          document.querySelector(
            '#CartDrawer-Overlay'
          );


        overlay?.addEventListener(
          'click',
          () => {
            drawer.close?.();
          },
          {
            once: true
          }
        );


        drawer
          .querySelectorAll(
            '.drawer__close, [data-drawer-close]'
          )
          .forEach((button) => {

            button.addEventListener(
              'click',
              () => {
                drawer.close?.();
              },
              {
                once: true
              }
            );

          });


      } catch (error) {

        console.log(
          'Cart drawer refresh:',
          error
        );

      }

    }


    /* =========================================
       OPTIONAL MANUAL REFRESH

       window.__cartUpdater.refresh()
    ========================================= */
  }


  new CartUpdaterLite();


  /* =========================================
     OPTIONAL DEBUG

     Console:
     cartStatus()
  ========================================= */

  window.cartStatus = () => {

    const wrapper =
      document.querySelector(
        '#cart-icon-bubble'
      );


    const bubble =
      wrapper?.querySelector(
        '.cart-count-bubble'
      );


    const span =
      bubble?.querySelector(
        '[aria-hidden="true"]'
      );


    console.log({

      wrapperFound:
        !!wrapper,

      bubbleFound:
        !!bubble,

      dataCartCount:
        wrapper?.getAttribute(
          'data-cart-count'
        ),

      display:
        bubble
          ? (
              bubble.style.display ||
              getComputedStyle(
                bubble
              ).display
            )
          : null,

      text:
        span?.textContent ??
        null

    });

  };

})();



// ------------------- OLD Cart updater sript iftikhar--------------



// (function () {
//     const CONFIG = {
//       TARGET_SELECTOR: '#cart-icon-bubble',
//       POLL_MS: 1500
//     };

//     class CartUpdater {
//       constructor() {
//         this.currentUrl = location.href;
//         this.wrapper = null;
//         this._kickT = this._urlT = this._pollT = null;
//         this.init();
//       }

//       init() {
//         this.resolveWrapper();

//         window.addEventListener('pageshow', () => this.updateSoon(40));
//         window.addEventListener('focus', () => this.updateSoon(40));

//         this._urlT = setInterval(() => {
//           if (location.href !== this.currentUrl) {
//             this.currentUrl = location.href;
//             this.updateSoon(60);
//           }
//         }, 150);

//         document.addEventListener('visibilitychange', () => {
//           if (!document.hidden) this.updateSoon(60);
//         });

//         this._pollT = setInterval(() => this.updateCartCountOnly(), CONFIG.POLL_MS);

//         this.mo = new MutationObserver(this.onMutate.bind(this));
//         this.mo.observe(document.documentElement, { childList: true, subtree: true });

//         this.updateSoon(150);
//       }

//       onMutate() {
//         const prev = this.wrapper;
//         this.resolveWrapper();
//         if (this.wrapper && this.wrapper !== prev) this.updateSoon(40);
//       }

//       resolveWrapper() {
//         const w = document.querySelector(CONFIG.TARGET_SELECTOR);
//         if (w) this.wrapper = w;
//       }

//       updateSoon(ms) {
//         clearTimeout(this._kickT);
//         this._kickT = setTimeout(() => this.updateCompleteCart(), ms);
//       }

//       async fetchCart() {
//         const res = await fetch('/cart.js?' + Date.now(), {
//           headers: { 'Cache-Control': 'no-cache' }
//         });
//         return res.json();
//       }

//       async updateCompleteCart() {
//         try {
//           const cart = await this.fetchCart();
//           this.updateCartCountUI(cart.item_count);
//           await this.updateDrawer(cart);
//         } catch (e) {
//           console.log('CartUpdater error:', e);
//         }
//       }

//       async updateCartCountOnly() {
//         try {
//           const cart = await this.fetchCart();
//           this.updateCartCountUI(cart.item_count);
//         } catch {}
//       }

//       ensureBubble(wrapper) {
//         if (!wrapper) return null;

//         let bubble = wrapper.querySelector('.cart-count-bubble');
//         if (bubble) return bubble;

//         if (wrapper.dataset.bubbleAttached === '1') {
//           return wrapper.querySelector('.cart-count-bubble');
//         }

//         bubble = document.createElement('div');
//         bubble.className = 'cart-count-bubble';
//         bubble.innerHTML = '<span aria-hidden="true">0</span><span class="visually-hidden">items in cart</span>';
//         wrapper.appendChild(bubble);
//         wrapper.dataset.bubbleAttached = '1';
//         return bubble;
//       }

//       updateCartCountUI(itemCount) {
//         const wrapper = this.wrapper;
//         if (!wrapper) return false;

//         const bubble = this.ensureBubble(wrapper);
//         if (!bubble) return false;

//         let span = bubble.querySelector('[aria-hidden="true"]');
//         if (!span) {
//           span = document.createElement('span');
//           span.setAttribute('aria-hidden', 'true');
//           bubble.prepend(span);
//         }

//         const current = parseInt(span.textContent) || 0;
//         if (current === itemCount) return false;

//         span.textContent = itemCount;
//         wrapper.setAttribute('data-cart-count', String(itemCount));

//         const clickable = /^(A|BUTTON)$/i.test(wrapper.tagName) ? wrapper : wrapper.querySelector('a,button');
//         if (clickable) {
//           const base = (clickable.getAttribute('data-base-label') ||
//                         clickable.getAttribute('aria-label') || 'Cart')
//                         .replace(/\s*\(\d+\)\s*$/, '');
//           clickable.setAttribute('data-base-label', base);
//           clickable.setAttribute('aria-label', `${base} (${itemCount})`);
//         }

//         bubble.style.display = itemCount > 0 ? 'flex' : 'none';
//         bubble.style.transition = 'transform 0.2s ease';
//         bubble.style.transform = 'scale(1.22)';
//         setTimeout(() => bubble.style.transform = 'scale(1)', 200);

//         return true;
//       }

//       async updateDrawer(cart) {
//         try {
//           const drawer = document.querySelector('cart-drawer');
//           if (!drawer) return;

//           if (cart.item_count === 0) {
//             drawer.classList.add('is-empty');
//             return;
//           }

//           const res = await fetch('/cart?section_id=cart-drawer&ts=' + Date.now(), {
//             headers: { 'Cache-Control': 'no-cache' }
//           });
//           const html = await res.text();
//           const doc = new DOMParser().parseFromString(html, 'text/html');
//           const newCart = doc.querySelector('cart-drawer');
//           if (!newCart) return;

//           drawer.classList.remove('is-empty');
//           drawer.innerHTML = newCart.innerHTML;

//           const overlay = document.querySelector('#CartDrawer-Overlay');
//           overlay?.addEventListener('click', () => drawer.close?.());

//           document.querySelectorAll('.drawer__close, [data-drawer-close]')
//             .forEach(btn => btn.addEventListener('click', () => drawer.close?.()));
//         } catch (e) {
//           console.log('Drawer error:', e);
//         }
//       }
//     }

//     window.__cartUpdater = new CartUpdater();

//     window.cartStatus = () => {
//       const w = document.querySelector('#cart-icon-bubble');
//       const b = w?.querySelector('.cart-count-bubble');
//       const s = b?.querySelector('[aria-hidden="true"]');
//       console.log({
//         wrapperFound: !!w,
//         bubbleFound: !!b,
//         attachedFlag: w?.dataset.bubbleAttached,
//         dataCartCount: w?.getAttribute('data-cart-count'),
//         display: b ? (b.style.display || getComputedStyle(b).display) : null,
//         text: s ? s.textContent : b?.textContent
//       });
//     };
//   })();